var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13467_21004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5C11.0304 3.5 11.5391 3.71071 11.9142 4.08579C12.2893 4.46086 12.5 4.96957 12.5 5.5M14.5 5.5C14.5001 6.08341 14.3726 6.65978 14.1263 7.18869C13.8801 7.7176 13.5212 8.18625 13.0747 8.56178C12.6282 8.93731 12.105 9.21062 11.5417 9.36256C10.9785 9.5145 10.3888 9.54139 9.814 9.44133C9.43867 9.37667 9.04133 9.45867 8.772 9.728L7 11.5H5.5V13H4V14.5H1.5V12.6213C1.5 12.2233 1.658 11.8413 1.93933 11.5607L6.272 7.228C6.54133 6.95867 6.62333 6.56133 6.55867 6.186C6.46413 5.64011 6.48402 5.08054 6.61709 4.54274C6.75015 4.00494 6.99348 3.50065 7.33165 3.06182C7.66983 2.62299 8.09547 2.25919 8.58161 1.99349C9.06775 1.72779 9.60379 1.56597 10.1557 1.51829C10.7077 1.47061 11.2636 1.53811 11.7881 1.71651C12.3126 1.89491 12.7943 2.18032 13.2027 2.55465C13.6111 2.92899 13.9373 3.38408 14.1606 3.8911C14.384 4.39811 14.4995 4.94599 14.5 5.5Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13467_21004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ff210df007a30e268f43c6ecd37a4f34.svg";
export { ForwardRef as ReactComponent };